export const languages = {
  endonyms: {
    en: "English",
    es: "Español",
    "es-cl": "Español Chileno",
    "es-419": "Español Latino",
    pt: "Português",
    ru: "русский",
    fr: "Français",
    "fr-ca": "Français canadien",
    de: "Deutsche",
    ja: "日本語 (にほんご)",
    ko: "한국어",
    ms: "Bahasa Melayu",
    th: "ไทย",
    vi: "Tiếng Việt",
    id: "Bahasa Indonesia",
    "zh-hans": "简体中文",
    "zh-hant": "正體中文"
  },
  names: {
    en: "English",
    es: "Spanish",
    "es-cl": "Spanish Chilean",
    "es-419": "Spanish Latin",
    pt: "Portuguese",
    ru: "Russian",
    fr: "French",
    "fr-ca": "Canadian French",
    de: "German",
    ja: "Japanese",
    ko: "Korean",
    ms: "Malay",
    th: "Thai",
    vi: "Vietnamese",
    id: "Indonesian",
    "zh-hans": "Chinese (Simplified)",
    "zh-hant": "Chinese (Traditional)"
  }
};
